export default {
    blockCardSelectCardOption: {
        dataTrackId: 'block-card-select-card-option',
        dataTrackLinkname: 'sperr kort - kortalternativ',
    },
    selectBlockType: {
        dataTrackId: 'select-block-type',
        dataTrackLinkname: `['SOFT_BLOCK', 'HARD_BLOCK', 'TERMINATE_ACCOUNT']`,
    },
    blockSelectedCardForm: {
        dataTrackId: 'block-selected-card-form',
        dataTrackLinkname: 'sperr valgt kort skjema',
    },
    blockCardCancel: {
        dataTrackId: 'block-card-cancel',
        dataTrackLinkname: 'avbryt sperr kort',
    },
    blockCardNext: {
        dataTrackId: 'block-card-next',
        dataTrackLinkname: 'neste',
    },
    hardBlockCardError: {
        dataTrackId: 'hard-block-card-error',
        dataTrackLinkname: 'permanent sperring av kort - feil',
    },
    hardBlockCardSuccessOk: {
        dataTrackId: 'hard-block-card-success-ok',
        dataTrackLinkname: 'permanent sperring av kort - suksess ok',
    },
    hardBlockCardCancel: {
        dataTrackId: 'hard-block-card-cancel',
        dataTrackLinkname: 'avbryt sperr kort',
    },
    hardBlockCardConfirm: {
        dataTrackId: 'hard-block-card-confirm',
        dataTrackLinkname: 'bekreft permanent sperring av kort',
    },
    hardBlockCardSuccessReceipt: {
        dataTrackId: 'hard-block-card-success-receipt',
        dataTrackLinkname: 'permanent sperr kort - suksess kvittering',
    },
    hardBlockCardConfirmForm: {
        dataTrackId: 'hard-block-card-confirm-form',
        dataTrackLinkname: 'bekreft permanent sperring av kort',
    },
    softBlockCardError: {
        dataTrackId: 'soft-block-card-error',
        dataTrackLinkname: 'midlertidig sperring av kort - feil',
    },
    softBlockCardSuccessOk: {
        dataTrackId: 'soft-block-card-success-ok',
        dataTrackLinkname: 'midlertidig sperring av kort - suksess ok',
    },
    softBlockCardCancel: {
        dataTrackId: 'soft-block-card-cancel',
        dataTrackLinkname: 'avbryt sperr kort',
    },
    softBlockCardConfirm: {
        dataTrackId: 'soft-block-card-confirm',
        dataTrackLinkname: 'bekreft midlertidig sperring av kort',
    },
    softBlockCardSuccessReceipt: {
        dataTrackId: 'soft-block-card-success-receipt',
        dataTrackLinkname: 'midlertidig sperr kort - suksess kvittering',
    },
    softBlockCardConfirmForm: {
        dataTrackId: 'soft-block-card-confirm-form',
        dataTrackLinkname: 'bekreft midlertidig sperring av kort',
    },
    blockFormSelectCard: {
        dataTrackId: 'block-form-select-card',
        dataTrackLinkname: 'sperr kort - velg kort',
    },
    selectReorderCardOption: {
        dataTrackId: 'select-reorder-card-option',
        dataTrackLinkname: `['YES', 'NO']`,
    },
    blockFormSelectOrderCardForm: {
        dataTrackId: 'block-form-select-order-card-form',
        dataTrackLinkname: 'sperr kort - velg rebestilling av kort',
    },
    selectHardBlockReasonOption: {
        dataTrackId: 'select-hard-block-reason-option',
        dataTrackLinkname: `['LOST', 'STOLEN', 'DAMAGED', 'NOT_IN_USE']`,
    },
    blockFormSelectReasonForHardBlockForm: {
        dataTrackId: 'block-form-select-reason-for-hard-block-form',
        dataTrackLinkname: 'sperr kort - velg arsak',
    },
    blockCardSelectCardOptionAgain: {
        dataTrackId: 'block-card-select-card-option',
        dataTrackLinkname: 'sperr kort - kortalternativ',
    },
};
